<p-tree
    #tree
    class="unified-p-tree p-tree-with-inverse-selection"
    selectionMode="checkbox"
    [value]="values() || []"
    [selection]="selectedValues()"
    (onNodeSelect)="setSelections(tree, $event)"
    (onNodeUnselect)="setSelections(tree)"
    [filter]="true"
    [filterPlaceholder]="`Filter ${label()}...`"
    scrollHeight="flex">
    <ng-template pTemplate="filtericon"><i class="pi pi-filter"></i></ng-template>
    <ng-template pTemplate="header">
        <div class="p-tree-header flex justify-content-between">
            <p-checkbox
                inputId="selectAllCheckbox"
                [binary]="true"
                [disabled]="values().length === 0"
                [ngModel]="isAllSelected()"
                (onChange)="selectAll($event.checked)"
                pTooltip="Select/Deselect All"
                tooltipPosition="right">
            </p-checkbox>
            <button
                pButton
                type="button"
                class="unified-flat-button"
                [disabled]="selectedValues().length === 0"
                (click)="selectInverse()"
                pTooltip="Selects the opposite of the current selection"
                tooltipPosition="top">
                <i class="g-inverse"></i>
                <span>Select Inverse</span>
            </button>
        </div>
    </ng-template>
</p-tree>